import { useState } from 'react';
import { Button } from '../common/Button';

interface ProjectActionsProps {
  state: string;
  onTransition: (action: string, reason?: string) => Promise<void>;
  isLoading?: boolean;
}

const TRANSITIONS: Record<string, { action: string; label: string; variant: 'primary' | 'secondary' | 'danger' | 'ghost' }[]> = {
  draft: [
    { action: 'start', label: 'Start Project', variant: 'primary' },
    { action: 'cancel', label: 'Archive', variant: 'danger' },
  ],
  in_progress: [
    { action: 'pause', label: 'Pause', variant: 'secondary' },
    { action: 'complete', label: 'Complete', variant: 'primary' },
    { action: 'cancel', label: 'Archive', variant: 'danger' },
  ],
  paused: [
    { action: 'resume', label: 'Resume', variant: 'primary' },
    { action: 'cancel', label: 'Archive', variant: 'danger' },
  ],
  completed: [
    { action: 'reopen', label: 'Reopen', variant: 'secondary' },
  ],
  cancelled: [
    { action: 'reopen', label: 'Reopen', variant: 'secondary' },
  ],
};

export default function ProjectActions({ state, onTransition, isLoading }: ProjectActionsProps) {
  const [pendingAction, setPendingAction] = useState<string | null>(null);

  const actions = TRANSITIONS[state];
  if (!actions || actions.length === 0) return null;

  const handleClick = async (action: string) => {
    setPendingAction(action);
    try {
      await onTransition(action);
    } finally {
      setPendingAction(null);
    }
  };

  return (
    <div className="flex items-center gap-2 bg-white rounded-lg border border-gray-200 px-4 py-3">
      <span className="text-sm text-gray-500 mr-2">Actions:</span>
      {actions.map(({ action, label, variant }) => (
        <Button
          key={action}
          variant={variant}
          size="sm"
          onClick={() => handleClick(action)}
          isLoading={isLoading && pendingAction === action}
          disabled={isLoading}
        >
          {label}
        </Button>
      ))}
    </div>
  );
}
